import React, { useEffect, useMemo, useState } from 'react';
import { createUseStyles } from 'react-jss';

import Paper from '../../components/Paper';
import clsx from 'clsx';

import { CartItem } from '../../types';
import Text from '../../components/Text';
import Button from '../../components/Button';
import {FLAVOUR,vatRate,currencyName} from '../../config/serverInfo';
export interface SummaryProps {
  cart: CartItem[];
  onProceed: () => any;
  step: string;
  deliveryCost: number;
  isSubmitting: boolean;
  discount: number;
  paymentCost: number;
}

const Summary: React.FC<SummaryProps> = ({
  cart,
  deliveryCost,
  onProceed,
  step,
  isSubmitting,
  discount,
  paymentCost
}) => {
  const classes = useStyles();
  const subTotal = useMemo(() => {
    console.log("cart")
    console.log(cart)
    return cart.reduce((prev, item) => {
      const itemPrice = item.variant ? item.variant.price : item.product.discountedPrice == item.product.originalPrice || item.product.discountedPrice == 0 ? item.product.originalPrice : item.product.discountedPrice;
      return itemPrice * item.quantity + prev;
    }, 0);
  }, [cart]);

  if (step == 'cart')
    deliveryCost = 0
  
  useEffect(() => {
    
  }, [])
   const vat = (((subTotal - discount + deliveryCost + paymentCost) * vatRate) / 100).toFixed(2);
   const total = (subTotal - discount + deliveryCost + paymentCost + parseFloat(vat)).toFixed(2);
   const items = cart.reduce((prev, item) => prev + item.quantity, 0);
  return (
    <>
      <Paper withShadow={false} className={clsx(classes.bigScreenPaper, 'p-3')}>
        <Text as="h5" className="mb-3" bold>
          Order Summary
        </Text>


    {/* USD TASK */}
    <div className={classes.textBox}>
            <Text as="span" bold>Total
              {
                step === 'cart' ?
                  ' (Subtotal)'
                  : ' (Subtotal + Payment + Delivery)'
              }
            </Text>
            <Text as="span" >
              {(subTotal + deliveryCost + paymentCost).toFixed(2)} {currencyName}
            </Text>
          </div>
          
          <div className={classes.textBox}>
            <Text as="span" bold>Discount</Text>
            <Text as="span">
              {(discount).toFixed(2)} {currencyName}
            </Text>
          </div>
        {FLAVOUR=="US" ? (
          <div className={classes.textBox}>
            <Text as="span" bold>Grand Total(Tax included)</Text>
            <Text as="span">
              {total} {currencyName}
            </Text>
          </div>
        ) :
        (
          <div className={classes.textBox}>
            <Text as="span" bold>Grand Total ({vatRate + "%"} VAT)</Text>
            <Text as="span">
              {total} {currencyName}
            </Text>
          </div>
        )}
        <div className="text-center py-3">
          <Button
            size="wide"
            onClick={onProceed}
            disabled={isSubmitting}
            rounded
          >
            <Text className="m-0" color="white" bold>
              {step === 'cart'
                ? 'Proceed to payment'
                : step === 'payment'
                  ? 'Proceed to checkout'
                  : 'Place your Order'}
            </Text>
          </Button>
        </div>
      </Paper>

      <Paper withShadow={false} className={clsx(classes.smallScreenPaper, 'p-2')}>
        <div className={clsx('m-auto', classes.smallScreenSummaryBox)}>
          <div className="p-1">
            <Text className={classes.smallScreenText} bold>
              Sub Total
            </Text>
            <Text as="span" className={classes.smallScreenText}>{subTotal} {currencyName}</Text>
          </div>
          <div className="p-1">
            <Text className={classes.smallScreenText} bold>
              ({items}) Items
            </Text>
          </div>
          <div className="p-1">
            <Text className={classes.smallScreenText} bold>
              VAT ({vatRate + "%"})
            </Text>
            <Text as="span" className={classes.smallScreenText}>{vat} {currencyName}</Text>
          </div>
          <div className="p-1">
            <Text className={classes.smallScreenText} bold>
              Total
            </Text>
            <Text className={classes.smallScreenText}>{total} {currencyName}</Text>
          </div>
        </div>
        <div className="m-auto">
          <Button
            type="button"
            onClick={onProceed}
            disabled={isSubmitting}
            rounded
          >
            <Text className="m-0" color="white" bold>
              {step === 'cart'
                ? 'Proceed to payment'
                : step === 'payment'
                  ? 'Proceed to checkout'
                  : 'Place Order'}
            </Text>
          </Button>
        </div>
      </Paper>
    </>
  );
};

const useStyles = createUseStyles({
  bigScreenPaper: {
    position: 'fixed',
    width: '100%',
    maxWidth: '387px',
    '@media (max-width: 1024px)': {
      display: 'none',
    },
    '@media (max-width: 1280px)': {
      maxWidth: '300px',
    },
  },
  smallScreenPaper: {
    display: 'none',
    '@media (max-width: 1024px)': {
      position: 'fixed',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      bottom: '60px',
      left: 0,
      right: 0,
    },
    '@media (min-height: 800px)': {
      bottom: '150px',
  },
},
  smallScreenSummaryBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  smallScreenText: {
    fontSize: '14px',
  },
  textBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default Summary;
